<footer>
  <div class="footcontainer">
    <div class="listemention">
      <a href="/mentions-legales-et-cgu" target="_blank"
        >Mentions légales et CGU</a
      >
      <a
        href="https://www.meilleurtaux.com/a-propos-de-meilleurtaux/politique-donnee.html"
        target="_blank"
        >Données personnelles</a
      >
      <a href="/reclamations" target="_blank">Réclamations</a>
    </div>

    <div class="Copyright">
      <p>Copyright© {{ getCurrentYear() }}</p>
    </div>
    <hr class="separator" />
    <div class="afi-description">
      <p>
        Meilleurtaux Santé est une marque exploitée par ACTIVE ASSURANCES
        (société du Groupe Meilleurtaux) SAS au capital de 30.000€ - RCS Paris -
        527 496 699 - Société de courtage d'assurances immatriculée à l'ORIAS
        (<a href="https://orias.fr" target="_blank">Orias</a>) sous le numéro
        10058420 - CS 92459 - 75436 Paris CEDEX 09
      </p>
    </div>
  </div>
</footer>
